export const ayudasRoutes = (apiBase) => ({
  ayudas: `${apiBase}/ayudas`,
  ayudasDetalle: `${apiBase}/ayudas/detalle`,
  ayudasAdminReset: `${apiBase}/ayudas/admin/reset`,
});
